// @ts-nocheck

import PropTypes from 'prop-types'
import React from 'react'
import { ProfilePicture } from '../ProfilePicture'

const ResidentSelectOption = ({ name, picture }) => {
  const displayName =
    name.first || name.last ? `${name.first} ${name.last}` : name
  return (
    <div style={styles.wrapper}>
      <ProfilePicture url={picture} style={styles.image} type="tiny" />
      <span style={styles.name}>{displayName}</span>
    </div>
  )
}

const styles = {
  image: {
    flexShrink: 0,
    marginRight: 12
  },
  wrapper: {
    alignItems: 'center',
    display: 'flex'
  }
}

ResidentSelectOption.propTypes = {
  name: PropTypes.shape({
    first: PropTypes.string,
    last: PropTypes.string
  }).isRequired,
  picture: PropTypes.string
}

export default ResidentSelectOption
